module.exports = __webpack_public_path__ + "img/success.e2edf3df.png";